import React from 'react';
import PropTypes from 'prop-types';

const Select = (props) => {
  const classes = props.className ? props.className : '';
  const classNames = `form-group ${classes}`;
  return(
    <div className={classNames}>
      <label htmlFor={props.name}> {props.title} </label>
      <select
        name={props.name}
        value={props.value}
        onChange={props.handleChange}
        placeholder={props.placeholder}
      >
        <option value="" disabled>{props.placeholder}</option>
        {props.options.map(option => {
          return (
            <option
              key={option}
              value={option}
              label={option}>{option}
            </option>
          );
        })}
      </select>
    </div>)
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default Select;